import { createColorsForUser, createYears } from 'Helpers/Calendar'

export default () => ({
  items: [],
  colors: createColorsForUser(),
  years: createYears(),
})
